export { arLocale } from './chronos/i18n/ar';
export { csLocale } from './chronos/i18n/cs';
export { daLocale } from './chronos/i18n/da';
export { deLocale } from './chronos/i18n/de';
export { enGbLocale } from './chronos/i18n/en-gb';
export { esLocale } from './chronos/i18n/es';
export { esDoLocale } from './chronos/i18n/es-do';
export { esUsLocale } from './chronos/i18n/es-us';
export { fiLocale } from './chronos/i18n/fi';
export { frLocale } from './chronos/i18n/fr';
export { hiLocale } from './chronos/i18n/hi';
export { huLocale } from './chronos/i18n/hu';
export { idLocale } from './chronos/i18n/id';
export { itLocale } from './chronos/i18n/it';
export { jaLocale } from './chronos/i18n/ja';
export { koLocale } from './chronos/i18n/ko';
export { mnLocale } from './chronos/i18n/mn';
export { nlLocale } from './chronos/i18n/nl';
export { nlBeLocale } from './chronos/i18n/nl-be';
export { plLocale } from './chronos/i18n/pl';
export { ptBrLocale } from './chronos/i18n/pt-br';
export { svLocale } from './chronos/i18n/sv';
export { ruLocale } from './chronos/i18n/ru';
export { roLocale } from './chronos/i18n/ro';
export { zhCnLocale } from './chronos/i18n/zh-cn';
export { trLocale } from './chronos/i18n/tr';
export { heLocale } from './chronos/i18n/he';
export { thLocale } from './chronos/i18n/th';
export { slLocale } from './chronos/i18n/sl';
export { glLocale } from './chronos/i18n/gl';
//# sourceMappingURL=locale.js.map


//////////////////
// WEBPACK FOOTER
// /deploy/www/v2/sa/app/emr-webapp/~/ngx-bootstrap/locale.js
// module id = ../../../../ngx-bootstrap/locale.js
// module chunks = 5